import React from "react";

import RemoveIcon from "../../assets/icons/commons/remove.svg";
import Coupang from "../Coupang";
import IngredientAction from "./Ingredient";
import { type TIngredient } from "modules/Ingredients/store/types";
import Cart from "./Cart";
import { LanguageCode } from "core/constants";
// import { useSelector } from "react-redux";

export enum ActionType {
  REMOVE = "REMOVE",
  ADD = "ADD",
  ADDCART = "ADDCART",
  COUPANG = "COUPANG",
}

interface GroupActionProps {
  handleClickIcon: (type: ActionType) => void;
  isRemove?: boolean;
  isCart?: boolean;
  ingredient_id: number;
  ingredient?: TIngredient;
}

const GroupAction: React.FC<GroupActionProps> = ({
  handleClickIcon,
  isRemove,
  isCart = true,
  ingredient_id,
  ingredient,
}) => {
  // const user = useSelector((state: any) => state.Auth.userInfo);

  const handleClick = (type: ActionType) => {
    handleClickIcon(type);
  };

  return (
    <div className="flex item-center justify-end gap-2">
      {ingredient ? <IngredientAction ingredient={ingredient} /> : null}

      {isRemove && (
        <img
          src={RemoveIcon}
          alt=""
          onClick={() => handleClick(ActionType.REMOVE)}
        />
      )}
      {isCart && ingredient && ( <Cart ingredient={ingredient} />)} 
      {
        (window as any)._APP_LANG === LanguageCode.ko && <Coupang ingredient_id={ingredient_id} />
      }
    </div>
  );
};

export default GroupAction;
